import { ARABIC_SCRIPT, normalizeName } from '@pa/core';

/** Latin names in title case; Arabic (or mixed) names exactly as entered (shared with the API). */
export function displayFirstName(name: string | null | undefined): string {
  return normalizeName(name);
}

/** One or two initials for the avatar; Latin upper-cased, Arabic as is. */
export function initials(
  first: string | null | undefined,
  last: string | null | undefined,
): string {
  const a = (first ?? '').trim();
  const b = (last ?? '').trim();
  const pick = (s: string) => (s ? ([...s][0] ?? '') : '');
  const out = `${pick(a)}${pick(b)}`;
  return ARABIC_SCRIPT.test(out) ? out : out.toLocaleUpperCase();
}
